import { Search } from '@/DTOS/User/Search';
import request from '../../utils/request';

const AgentService = {
  search: (search: Search) => {
    return request('/agent/search', {
      method: 'POST',
      body: JSON.stringify({ request: { ...search } }),
    });
  },

  upsert: (
    id: any,
    formData: {
      name: any;
      phone: any;
      email: any;
      role: any;
      isActive: any;
      isDefaultOnInterventionFile: any;
      receivesInterventionFileEmails: any;
      workPlaceId?: any;
      companyId?: any;
    }
  ) => {
    const handleFieldValue = (fieldValue: string | string[]) => {
      if (Array.isArray(fieldValue)) {
        return fieldValue;
      } else {
        return [fieldValue];
      }
    };

    return request('/agent/upsert', {
      method: 'POST',
      body: JSON.stringify({
        request: {
          id: id,
          name: formData.name,
          phone: handleFieldValue(formData.phone),
          email: handleFieldValue(formData.email),
          role: handleFieldValue(formData.role),
          isActive: formData.isActive,
          isDefaultOnInterventionFile: formData.isDefaultOnInterventionFile,
          receivesInterventionFileEmails: formData.receivesInterventionFileEmails,
          workPlaceId: formData.workPlaceId,
          companyId: formData.companyId,
        },
      }),
    });
  },
};

export default AgentService;
